/**
 * CMAB API source
 * @module
 */
/* eslint-disable no-restricted-globals */
var _ = require('optimizely-client-fn');
var JSONEnv = require('core/lib/json');
var XHR = require('core/utils/xhr');
var Logger = require('core/utils/logger');
var Visitor = require('core/visitor');
var cmabService = require('plugins/feature_cmab/cmabService');
var STATUS_OK = 200;

var API_ENDPOINT = __CMAB_PREDICTION_URL__;
var PREDICT_ROUTE = 'predict';

exports.getCmabPredictionUrl = function (): string {
  return `${API_ENDPOINT}/${PREDICT_ROUTE}`;
};

exports.getCmabPredictionUrlForExperiment = function (experimentId: string): string {
  if (!experimentId) return '';
  return `${exports.getCmabPredictionUrl()}/${experimentId}`;
};

exports.createPayload = function (experiment: Experiment, cmabUUID: string): any {
  var variationIds = _.map(experiment.variations, 'id');
  var attributes = cmabService.getVisitorCmabAttributesForExperiment(experiment);
  var dcpCustomerIds = cmabService.getDcpCustomerIds();
  var dcpServiceId = cmabService.getDcpServiceId();

  return {
    instances: [
      {
        visitorId: Visitor.getCurrentId(),
        experimentId: experiment.id,
        cmabUUID: cmabUUID,
        variationIds: variationIds,
        attributes: attributes,
        dcpCustomerIds: dcpCustomerIds,
        dcpServiceId: dcpServiceId,
      }
    ]
  };
};

exports.parseApiResponse = function (responseText) {
  var data = null;
  try {
    data = JSONEnv.parse(responseText);
  } catch (error) {
    Logger.error('CMAB API / Error parsing response:', error);
    return null;
  }

  if (!data || !data.predictions || data.predictions.length === 0) {
    Logger.debug('CMAB API / No predictions found in API response', data);
    return null;
  }

  var variationId = data.predictions[0].variation_id.toString();

  return variationId;
};

exports.validateVariationId = function (variationId, experiment) {
  if (!variationId || !_.find(experiment.variations, { id: variationId })) {
    Logger.debug('CMAB API / Variation ID:', variationId, 'from API response not found in experiment:', experiment.id);
    return null;
  }

  Logger.debug('CMAB API / Variation ID:', variationId, 'from API response found in experiment:', experiment.id);
  return variationId;
};

exports.handleCmabApiResponse = function (response, experiment) {
  if (response.status !== STATUS_OK) {
    Logger.error('CMAB API / API call failed with status:', response.status, response.statusText);
    return null;
  }

  Logger.debug('CMAB API / API call successful:', response.responseText);

  var variationId = exports.parseApiResponse(response.responseText);
  return exports.validateVariationId(variationId, experiment);
};

// New method using XMLHttpRequest directly
exports.makeSyncApiCallWithXHR = function (experiment, cmabUUID) {
  Logger.debug('CMAB API / SYNC / Making a synchronous API call to get variation.');

  try {
    var payload = exports.createPayload(experiment, cmabUUID);
    var url = exports.getCmabPredictionUrlForExperiment(experiment.id);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, false); // false makes the request synchronous
    xhr.send(JSONEnv.stringify(payload));
    return exports.handleCmabApiResponse(xhr, experiment);
  } catch (error) {
    Logger.error('CMAB API / SYNC / API call encountered an error:', error);
    return null;
  }
};

exports.makeAsyncApiCall = function (experiment, cmabUUID) {
  Logger.debug('CMAB API / ASYNC / Making an asynchronous API call to get variation.');

  var payload = exports.createPayload(experiment, cmabUUID);
  var url = exports.getCmabPredictionUrlForExperiment(experiment.id);

  return XHR.request({
    url: url,
    contentType: 'application/json',
    method: 'POST',
    data: payload
  });
};

